const reporterMethods = {
  report: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Report',
    httpMethod: 'put',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  GetReportsByFilter: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessReport/GetReportsByFilter',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  GetBusinessReportCoreData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessReport/GetBusinessReportCoreData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['type' , 'orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  
} 

export default reporterMethods;